var render = function render(){var _vm=this,_c=_vm._self._c;return _c('LogoWrapper',{attrs:{"src":_vm.src,"alt":"Stake: Your Voice through Your Investments","max-height":_vm.maxHeight,"max-width":_vm.maxWidth}})
}
var staticRenderFns = []

export { render, staticRenderFns }